var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3768 9.33852C11.3768 8.71628 11.624 8.11953 12.064 7.67954C12.504 7.23955 13.1007 6.99236 13.723 6.99236C14.7553 6.99236 15.6281 7.65867 15.9471 8.57836C16.0222 8.82236 16.0691 9.07575 16.0691 9.33852C16.0691 9.64662 16.0084 9.9517 15.8905 10.2364C15.7726 10.521 15.5998 10.7796 15.382 10.9975C15.1641 11.2154 14.9055 11.3882 14.6208 11.5061C14.3362 11.624 14.0311 11.6847 13.723 11.6847C12.7001 11.6847 11.8461 11.0371 11.5082 10.1268C11.4237 9.88283 11.3768 9.61067 11.3768 9.33852ZM5.27683 9.33852C5.27683 13.5616 10.0442 19.3425 10.9076 20.4218L9.96913 21.5385C9.96913 21.5385 3.3999 14.2654 3.3999 9.33852C3.3999 6.3636 5.38006 3.84852 8.09221 3.04144C6.36544 4.5899 5.27683 6.83283 5.27683 9.33852ZM13.723 2.76929C17.3454 2.76929 20.2922 5.70667 20.2922 9.33852C20.2922 14.2654 13.723 21.5385 13.723 21.5385C13.723 21.5385 7.15375 14.2654 7.15375 9.33852C7.15375 5.70667 10.1005 2.76929 13.723 2.76929ZM13.723 4.64621C11.1328 4.64621 9.03067 6.74836 9.03067 9.33852C9.03067 10.277 9.03067 12.1539 13.723 18.451C18.4153 12.1539 18.4153 10.277 18.4153 9.33852C18.4153 6.74836 16.3131 4.64621 13.723 4.64621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationwhite);
export default __webpack_public_path__ + "static/media/locationwhite.2ebd37345f87af281164cd8e58368aad.svg";
export { ForwardRef as ReactComponent };